type TimeRailProps = {
  durationMs: number;
};

export function TimeRail({ durationMs }: TimeRailProps) {
  return (
    <div className="time-rail" aria-hidden="true">
      <div style={{ animationDuration: `${durationMs}ms` }} />
    </div>
  );
}
